<template>
<div class="after-sale-list list-common">
  <!-- 筛选条件 -->
  <div class="query-div">
    <!-- 已选条件 -->
    <div class="selected-div">
      <div class="title text-red">售后记录</div>
    </div>
    <div>
    <p class="sub-title">请选择你需要查看的售后类型</p>
    <div class="flex-between">
      <div class="flex">
        <div class="type-btn" :class="typeIndex === 2 ? 'active':''" @click="handleChangeType(2)">退款退货</div>
        <div class="type-btn" :class="typeIndex === 3 ? 'active':''" @click="handleChangeType(3)">仅退款</div>
        <div class="type-btn" :class="typeIndex === 1 ? 'active':''" @click="handleChangeType(1)">换货</div>
      </div>
    </div>
    </div>
    <div v-if="orderList.length > 0" class="mt10">
      <div class="flex order-list" v-for="item in orderList" :key="item.id">
        <img class="order-img" :src="item.aftersalesItems && item.aftersalesItems.length > 0 && item.aftersalesItems[0].thumbnail" alt="">
        <div class="flex-1">
          <div class="flex-align-center mb20">
            <p class="order-title mr20">{{ item.merchIndustryName }}</p>
            <p class="order-time">退回时间：</p>
            <p class="order-time-black">{{ item.updTime }}</p>
          </div>
          <div class="flex-between">
            <div>
              <div class="flex-align-center" v-for="(subItem, subIdx) in item.aftersalesItems" :key="subItem.goodsId">
                <p v-if="subIdx < 2" class="order-goods">{{ subItem.goodsName }}</p>
                <p v-if="subIdx < 2" class="order-quantity">数量：<span>{{ subItem.quantity }}</span></p>
              </div>
              <img v-if="item.aftersalesItems.length > 2" src="../../assets/images/dot.png" alt="">
            </div>
            <div class="order-pay">退款金额：¥{{ item.refundAmount }}</div>
            <div class="text-right">
              <p class="text-blue mb20">{{ item.statusName }}</p>
              <div class="w368px text-right">
                <!-- 售后退货时,未填写运单号需要填写 -->
                <el-button v-if="item.status === 1 && !item.isSendBack && (item.type === 1 || item.type === 2)" class="red-line" @click="handleExpress(item.id)">填写快递单号</el-button>
                <el-button class="red-line ml12" @click="handleStep(item)">查看售后进度</el-button>
                <el-button v-if="item.status === 0" class="red-line ml12" @click="handleUndo(item.id, item.typeName)">撤销申请</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-data">暂无数据</div>
    <div class="pagination-self" v-if="totalCount > 0">
      <el-pagination background prev-text="上一页" next-text="下一页" layout="prev, pager, next"
      @current-change="handleCurrentChange" :total="totalCount">
      </el-pagination>
    </div>
  </div>
  <!-- 撤销申请 -->
  <UndoDialog :visible="undoDialogVisible" @handleCloseDialog="handleCloseDialog" @handleCancerAftersales="handleCancerAftersales" />
  <!-- 填写快递单号 -->
  <ExpressDialog :visible="expressDialogVisible" :shipCorps="shipCorps" @handleCloseDialog="handleCloseDialog" @handleTransitTabs="handleTransitTabs" />
</div>
</template>

<script>
import UndoDialog from '@/components/UndoDialog'
import ExpressDialog from '@/components/ExpressDialog'
import { loadAftersalesList } from '@/api/afterSales'
import { afterSalesMixin } from '@/mixins/afterSalesMixin'
export default {
  name: 'afterSalesOrderList',
  mixins: [afterSalesMixin],
  components: {
    UndoDialog,
    ExpressDialog
  },
  data () {
    return {
      typeIndex: 2,
      page: 1,
      limit: 10,
      orderList: [],
      totalCount: 0
    }
  },
  created () {
    this.page = 1
    this.$nextTick(() => {
      this.loadList()
    })
  },
  methods: {
    // 售后分页列表
    loadList () {
      const param = {
        page: this.page,
        limit: this.limit,
        type: this.typeIndex
      }
      loadAftersalesList(param).then(res => {
        if (res.code === 0) {
          this.orderList = res.data.list
          this.totalCount = res.data.totalCount
        }
      })
    },
    // 翻页
    handleCurrentChange (val) {
      this.page = val
      this.loadList()
    },
    handleChangeType (type) {
      this.typeIndex = type
      this.page = 1
      this.loadList()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/common/css/afterSales.scss';
</style>
